import React from "react";
import { Block, Link } from "thorium-ui";

const DevCard = (props) => {
   const bg = props.visible ? `url(${props.post.cover_image})` : undefined;
   return (
      <Block xs={12} sm={6} md={6} lg={3} xl={3}>
         <div className="dev-card">
            <div className="dev-card-image" style={{ backgroundImage: bg }} />
            <div className="dev-card-info">
               <p className="dev-card-title" title={props.post.title}>
                  {props.post.title}
               </p>
               <Link href={props.post.url} asAnchor target="_blank">
                  Read on DEV
               </Link>
            </div>
         </div>
      </Block>
   );
};

export default DevCard;
